import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Necesito experiencia previa en meditación?',
    a: 'No, este es un protocolo práctico diseñado para el mundo real.'
  }, {
    q: '¿Tengo que comprar piedras o inciensos?',
    a: 'No, todas las herramientas están dentro de tu propio sistema energético.'
  }, {
    q: '¿Funciona si trabajo en un hospital o lugar muy denso?',
    a: 'Sí, es precisamente donde más se nota su efectividad.'
  }, {
    q: '¿Es una suscripción?',
    a: 'No, es un pago único con acceso de por vida.'
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-navy-900" data-id="element-33">
      <div className="max-w-3xl mx-auto" data-id="element-34">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-35">
          <h2 className="text-3xl md:text-4xl font-serif text-white mb-6" data-id="element-36">
            Preguntas Frecuentes
          </h2>
          <div className="w-16 h-1 bg-gold-500 mx-auto" data-id="element-37" />
        </motion.div>

        <div className="space-y-4" data-id="element-38">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} index={index} data-id="element-39" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer,
  index
}: {
  question: string;
  answer: string;
  index: number;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.4,
    delay: index * 0.1
  }} className="border border-navy-700 rounded-lg overflow-hidden bg-navy-950/50" data-id="element-40">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-41">
        <span className="text-white font-medium pr-4" data-id="element-42">{question}</span>
        <ChevronDown className={`w-5 h-5 text-gold-400 transition-transform duration-300 flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-43" />
      </button>
      <AnimatePresence data-id="element-44">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-45">
            <div className="p-6 pt-0 text-gray-400 leading-relaxed border-t border-navy-800/50 mt-2" data-id="element-46">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
}